import {
  lastAssistantMessageIsCompleteWithApprovalResponses,
  lastAssistantMessageIsCompleteWithToolCalls,
  type UIMessage,
} from "ai";

export function shouldSendAutomatically(options: {
  messages: UIMessage[];
}): boolean {
  if (lastStepFailed(options.messages)) return false;
  return (
    lastAssistantMessageIsCompleteWithToolCalls(options) ||
    lastAssistantMessageIsCompleteWithApprovalResponses(options)
  );
}

function lastStepFailed(messages: UIMessage[]): boolean {
  const message = messages[messages.length - 1];
  if (message?.role !== "assistant") return false;
  const lastStepStart = message.parts.findLastIndex(
    (part) => part.type === "step-start"
  );
  return message.parts
    .slice(lastStepStart + 1)
    .some((part) => part.type === "data-error");
}
